
import Popup, { PopupProps } from '../Popup';
import ColorPicker, { ColorPickerProps } from './ColorPicker';

const ColorPickerPopup = (props: PopupProps & ColorPickerProps) => (
  <Popup component={ColorPicker} blockOnMobile {...props} />
);

export default ColorPickerPopup;
